import { format } from 'date-fns';

import { ExportWorkType } from '../types/export-work-type';

export const createFileName = (
  workType: ExportWorkType,
  filterName?: string
) => {
  return `APS_workflow_${workType}${
    filterName ? `_${filterName}` : ''
  }_${format(new Date(), 'ddMMMyyyy-HHmm')}`;
};
